import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { twMerge } from 'tailwind-merge';
const EllipsisSeparator = props => /*#__PURE__*/React.createElement("div", _extends({
  className: twMerge('flex items-center justify-center w-4 h-12 text-blue-700', props.disabled && 'pointer-events-none text-gray-500 bg-gray-200')
}, props), "\u2026");
export default EllipsisSeparator;